import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=63cf160e&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports